// File: src/pages/DashboardPage.tsx
// A cleaner version of the dashboard, inheriting styles from the global theme.

import React from 'react';
import {Box, Container, Divider, Paper, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useUser} from '../context/UserContext';

const DashboardPage = () => {
    const {user} = useUser();
    const {t} = useTranslation();

    return (
        <Container maxWidth="lg" sx={{py: 4}}>
            {/* +++ ДОБАВЛЕНО: Единый блок для заголовка +++ */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1">
                    {t('dashboard.title')}
                </Typography>
            </Box>

            {/*
        This Paper component automatically gets the rounded corners, border,
        background, and hover effect from the global theme override.
        The code is much cleaner now.
      */}
            <Paper sx={{p: {xs: 2, md: 4}, mb: 4}}>
                <Typography variant="h5" component="h2" sx={{mb: 1, color: 'text.primary'}}>
                    {t('dashboard.welcome_back', { name: user?.name || t('dashboard.user') })}
                </Typography>

                <Typography variant="body1" sx={{color: 'text.secondary', lineHeight: 1.6}}>
                    {t('dashboard.description')}
                </Typography>
            </Paper>

            {/* Quick Actions Section Placeholder */}
            <Box>
                <Typography variant="h6" component="h3" sx={{color: 'text.primary', fontWeight: 500, mb: 2}}>
                    {t('dashboard.quick_actions')}
                </Typography>
                <Divider sx={{mb: 2}}/>
                {/* We can even use an outlined variant for different styles */}
                <Paper variant="outlined" sx={{p: 4, textAlign: 'center', background: 'transparent'}}>
                    <Typography sx={{color: 'text.secondary'}}>
                        {t('dashboard.future_widgets')}
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
};

export default DashboardPage;
